const routes = {
  summaryEPS: (): string => `remunerationEPSTotal`,
  summaryTotal: (): string => `remunerationServiceCategoryTotal`,
  summaryEPSDetails: (epsId: string): string =>
    `remunerationDetails/?epsTotal=${epsId}`,
  summaryServiceCategoryDetails: (serviceCategoryId: string): string =>
    `remunerationDetails/?serviceCategoryTotal=${serviceCategoryId}`,
  invoiceDetails: (): string => `remunerationSubDetails`,
};

export default routes;
